module.exports = __webpack_public_path__ + "static/media/PlaceholderImage.f68a8aa4.jpg";